import z, { type ZodError } from 'zod';
import ErrorLogger from '@/services/logger/ErrorLogger';
import { createErrorWithCause } from '@/utils/createErrorWithCause';

export const logSchemaMismatchError = (error: ZodError, message: string) =>
  ErrorLogger.logError(createErrorWithCause(message, error), {
    schemaDetails: JSON.stringify(z.treeifyError(error)),
  });
